export const backendURL = process.env.REACT_APP_backurl
// export REACT_APP_backurl=http://localhost:8000